import React from "react";

const Component = () => (
  <div data-testid="placeholder">
    <h1>Settings</h1>
    <p>Update your preferences.</p>
  </div>
);

export default Component;

